document.addEventListener('DOMContentLoaded', function () {

  new Swiper('.announcement-bar_main', {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    },
    allowTouchMove: true, 
    autoHeight: false,
    navigation: false,
    pagination: false
  });
  const Runeswiper = new Swiper(".column-slider", {
    slidesPerView: 2.2,
    spaceBetween: 19,
    freeMode: false,
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
    },
    breakpoints: {
        
        768: {
          slidesPerView: 3.2,
          spaceBetween: 19,
        },
        1024: {
          slidesPerView: 4.4,
          spaceBetween: 19,
        },
    },
  });
  
  const productThumb = new Swiper('.pl--product_thumb', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 12,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
  });
  
  const productSlider = new Swiper('.pl--product_slider', {
    loop: true,
    slidesPerView: 1,
    effect: 'slide', // IMPORTANT for video stability
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: productThumb
    },
    observer: true,
    observeParents: true,
    watchOverflow: false,
  });

  const variantScript = document.querySelector(
    'variant-selects script[data-selected-variant]'
  );

  if (variantScript) {
    try {
      const activeVariant = JSON.parse(variantScript.textContent);

      const mediaSrc =
        activeVariant.featured_image?.src ||
        activeVariant.featured_media?.preview_image?.src;

      if (mediaSrc) {

        // Same matching logic as your Colour option click
        const optionBase = mediaSrc
          .split('?')[0]
          .replace(/_(\d+)\.(jpg|png|webp)$/i, '_');

        let targetIndex = null;

        productSlider.slides.forEach((slide, index) => {
          if (targetIndex !== null) return;

          const img = slide.querySelector('img');
          if (!img || !img.src) return;

          const slideBase = img.src
            .split('?')[0]
            .replace(/_(\d+)\.(jpg|png|webp)$/i, '_');

          if (slideBase.includes(optionBase)) {
            targetIndex = index;
          }
        });

        if (targetIndex !== null) {
          if (productSlider.params.loop) {
            productSlider.slideToLoop(targetIndex, 0);
          } else {
            productSlider.slideTo(targetIndex, 0);
          }
        } else {
          console.warn(
            'No matching slide found for active variant:',
            mediaSrc
          );
        }
      }

    } catch (error) {
      console.error('Unable to parse active variant:', error);
    }
  }

  document.addEventListener('click', function (e) {
    const option = e.target.closest('.cdk_gift_variant_option');
    if (!option) return;

    const img = option.querySelector('img');
    if (!img) return;

    const imageSrc = img.getAttribute('src');

    const getFileName = (url) => {
      if (!url) return '';

      url = url.split('?')[0];

      const parts = url.split('/');
      let file = parts[parts.length - 1];

      file = file.replace('_png.webp', '.png');

      return file;
    };

    const selectedFile = getFileName(imageSrc);

    // console.log('Selected file:', selectedFile);

    const wrapper = option.parentElement;
    if (wrapper) {
      wrapper.querySelectorAll('.cdk_gift_variant_option')
        .forEach(el => el.classList.remove('active'));
    }
    option.classList.add('active');

    let targetIndex = -1;

    productSlider.slides.forEach((slide, index) => {
      const slideImg = slide.querySelector('img');
      if (!slideImg) return;

      const slideFile = getFileName(slideImg.getAttribute('src'));

      if (slideFile === selectedFile) {
        targetIndex = index;
      }
    });

    if (targetIndex !== -1) {
      productSlider.slideToLoop(targetIndex);
    } else {
      console.warn('No matching slide found for:', selectedFile);
    }
  });

  document.addEventListener('click', function (e) {
    const option = e.target.closest('.more-option-display ul li');
    if (!option) return;
  
    const mediaSrc = option.dataset.mediaSrc;
    if (!mediaSrc) return;
  
    if (typeof productSlider === 'undefined' || !productSlider.slides) return;
  
    const optionBase = mediaSrc
      .split('?')[0]
      .replace(/_(\d+)\.(jpg|png|webp)$/i, '_');
  
    let targetIndex = null;
  
    productSlider.slides.forEach((slide, index) => {
      if (targetIndex !== null) return;
  
      const img = slide.querySelector('img');
      if (!img || !img.src) return;
  
      const slideBase = img.src
        .split('?')[0]
        .replace(/_(\d+)\.(jpg|png|webp)$/i, '_');
  
      if (slideBase.includes(optionBase)) {
        targetIndex = index;
      }
    });
  
    if (targetIndex === null) return;
  
    if (productSlider.params.loop) {
      productSlider.slideToLoop(targetIndex, 300);
    } else {
      productSlider.slideTo(targetIndex, 300);
    }
  });  

  new Swiper('.image-with-text-slider', {
    loop: true,
    effect: 'fade',
    autoHeight: false,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      1024: {
        slidesPerView: 1
      },
      600: {
        autoHeight: true,
        slidesPerView: 1
      },
      480: {
        slidesPerView: 1
      }
    }
  });
  const guardianSlider = new Swiper('.gaurdian-slider.slide', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    navigation: false,
    pagination: false,
    autoHeight: false,
    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
      749: {
        slidesPerView: 1,
        autoHeight: false,
      },
      480: {
        slidesPerView: 1,
        autoHeight: false,
      },
    },
  });
  const eventProductsSlider = new Swiper('.event_products_wrapper', {
    loop: true,
    slidesPerView: 3,
    slidesPerGroup: 1,
    autoplay: false,
    navigation: {
      nextEl: '.event-next',
      prevEl: '.event-prev',
    },
    pagination: false,
    autoHeight: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        autoHeight: true,
      },
      750: {
        slidesPerView: 2,
        autoHeight: true,
      },
      1025: {
        slidesPerView: 3,
      },
    },
  });
/* --------- Review Slider --------- */

const reviewSlider = new Swiper('.review-slider', {
    loop: true,
    slidesPerView: 3,
    slidesPerGroup: 1,
    autoplay: false,
    navigation: {
      nextEl: '.review-next',
      prevEl: '.review-prev',
    },
    pagination: false,
    autoHeight: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        autoHeight: true,
      },
      750: {
        slidesPerView: 2,
        autoHeight: true,
      },
      1024: {
        slidesPerView: 3,
      },
      
    },
  });
  /* --------- Start Launch Slider --------- */
  const launchSlider = new Swiper('.launch-slider', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    slidesPerView: 1,
    slidesPerGroup: 1,

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false, // Slick pauseOnHover: false
    },

    navigation: false,
    pagination: false,

    autoHeight: true,

    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
      749: {
        slidesPerView: 1,
        autoHeight: false,
      },
      480: {
        slidesPerView: 1,
        autoHeight: false,
      },
    },
  });
});